import * as React from 'react';
import { SubNavigationBar } from '@common/components/navigation-bar';
import { Switch } from '@common/components/router';
import { Route, useParams, useRouteMatch } from 'react-router';
import LibraryContainer from '../competency-library';
import EvaluationsContainer from '../evaluations';
import EvaluationFormsList from '../evaluation-forms';
import { useTranslation } from 'react-i18next';
import { useCanAccess } from '@common/hooks';
import { EPermissions } from '@common/definitions';
import MyEvaluationsContainer from '../my-evaluations/my-evaluations';
import { PermissionRoute } from '@common/components/route';
import PerformanceReviewContainer from '../performance-review';
import { combineClassNames } from '@common/utils/combineClassNames';

export const PerformanceContainer = () => {
  const { t } = useTranslation();
  const { networkId } = useParams<{ networkId: string }>();
  const baseUrl = networkId ? `/networks/${networkId}` : '/admin';
  const basePath = networkId ? '/networks/:networkId' : '/admin';
  const isNetworkRoute = useRouteMatch('/networks/:networkId');

  const canViewCompetencyAndForms = useCanAccess({
    permissions: [
      EPermissions.ORGANISATION_PERFORMANCE_REVIEW_FORMS_VIEW_ALL,
      EPermissions.ORGANISATION_PERFORMANCE_REVIEW_EVALUATIONS_MANAGEMENT,
    ],
  });

  const canViewEvaluations = useCanAccess({
    permissions: [
      EPermissions.ORGANISATION_PERFORMANCE_REVIEW_EVALUATIONS_VIEW_ALL,
      EPermissions.NETWORK_PERFORMANCE_REVIEW_EVALUATIONS_VIEW_ALL,
      EPermissions.ORGANISATION_PERFORMANCE_REVIEW_EVALUATIONS_MANAGEMENT,
      EPermissions.NETWORK_PERFORMANCE_REVIEW_EVALUATIONS_MANAGEMENT,
    ],
  });

  return (
    <>
      <SubNavigationBar
        title={t('performance:tab_performance')}
        className={combineClassNames('SubNavigationBar__Performance')}
      >
        {/* <SubNavigationBar.Item
          exact
          icon="file_02_bolt"
          path={`${baseUrl}/performance`}
          title={t('performance:cycles')}
        /> */}

        {!networkId && canViewCompetencyAndForms && (
          <>
            <SubNavigationBar.Item
              exact
              icon="grid_view"
              path={`${baseUrl}/performance`}
              title={t('performance:evaluation_forms')}
            />

            <SubNavigationBar.Item
              exact
              icon="briefcase_job"
              path={[
                `${baseUrl}/performance/competency-library/all`,
                `${baseUrl}/performance/competency-library/archived`,
              ]}
              title={t('performance:competency_library')}
            />
          </>
        )}

        {canViewEvaluations && (
          <SubNavigationBar.Item
            exact
            icon="file_02_check"
            path={`${baseUrl}/performance/evaluations`}
            title={t('performance:evaluations')}
          />
        )}
        {isNetworkRoute && (
          <SubNavigationBar.Item
            exact
            icon="file_02_check"
            path={`${baseUrl}/performance/my-evaluations`}
            title={t('performance:my_evaluations')}
          />
        )}
        {!isNetworkRoute && (
          <SubNavigationBar.Item
            exact
            icon="file_02_bar_graph"
            path={[
              `${baseUrl}/performance/reports/performance-rating`,
              `${baseUrl}/performance/reports/employees`,
              `${baseUrl}/performance/reports/talent-reviews`,
            ]}
            title={t('performance:reports')}
          />
        )}
      </SubNavigationBar>

      <Switch>
        {/* <Route
          exact
          path={`${basePath}/performance`}
          component={CyclesContainer}
        /> */}

        <Route
          exact
          path={`${basePath}/performance`}
          component={EvaluationFormsList}
        />

        <Route
          exact
          path={[
            `${basePath}/performance/competency-library/all`,
            `${basePath}/performance/competency-library/archived`,
          ]}
          component={LibraryContainer}
        />

        <PermissionRoute
          permission={{
            name: [
              EPermissions.ORGANISATION_PERFORMANCE_REVIEW_EVALUATIONS_VIEW_ALL,
              EPermissions.NETWORK_PERFORMANCE_REVIEW_EVALUATIONS_VIEW_ALL,
              EPermissions.ORGANISATION_PERFORMANCE_REVIEW_EVALUATIONS_MANAGEMENT,
            ],
          }}
          path={`${basePath}/performance/evaluations`}
          component={EvaluationsContainer}
        />

        {isNetworkRoute && (
          <Route
            exact
            path="/networks/:networkId/performance/my-evaluations"
            component={MyEvaluationsContainer}
          />
        )}

        <Route
          exact
          path={[
            `${basePath}/performance/reports/performance-rating`,
            `${basePath}/performance/reports/employees`,
            `${basePath}/performance/reports/talent-reviews`,
          ]}
          component={PerformanceReviewContainer}
        />
      </Switch>
    </>
  );
};
